
/**
 * @项目名称: work
 * @功能名称: 表单检测函数
 * @文件名称: mixin
 * @Date: 2019/9/18
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
import mixinFun from 'bjxy-common/vuePlugin/mixins'

const mixin = mixinFun({
  testRule: [
    {
      key: 'checked',
      tip: '请阅读并勾选协议'
    },
    {
      key: 'captchaCode',
      verify(value) {
        if (this.isNeedCaptcha) {
          return !!value
        } else {
          return true
        }
      },
      tip: '请填写图形验证码'
    },
    {
      key: 'mobile',
      verify(value) {
        return /^1\d{10}$/.test(value)
      },
      tip: '请填写正确格式的手机号'
    },
    {
      key: 'account',
      verify(value) {
        return /^1\d{10}$/.test(value)
      },
      tip: '请填写正确格式的手机号'
    },
    {
      key:'captchaObj',
      tip:'网络慢请稍等重试'
    },
    {
      key: 'username',
      verify(value) {
        return /^1\d{10}$/.test(value)
      },
      tip: '请填写正确格式的手机号'
    },
    {
      key: 'inviteMobile',
      verify(value) {
        return /^1\d{10}$/.test(value) || !value
      },
      tip: '请填写正确格式的邀请人手机号或者留空'
    },
    {
      key: 'password',
      verify(value) {
        return (value && /^.{6,16}$/.test(value))
      },
      tip: '请填写正确格式的登录密码（6--16位数字、字母）'
    },
    {
      key: 'smsCode',
      verify(value) {
        return /^\d{3,8}$/.test(value)
      },
      tip: '请填写短信验证码'
    },
    {
      key:'verifyCode',
      tip: '请填写短信验证码'
    },
    {
      key:'verifyId',
      tip:'请先获取短信验证码'
    },
    {
      key:'orderId',
      tip:'请先获取短信验证码'
    },
    {
      key:'code',
      tip:'请输入短信验证码'
    },
    {
      key:'id',
      tip: '请先获取短信验证码'

    }
  ]
})

export default mixin
